export default __webpack_public_path__ + "static/media/icon-stopwatch-line.a52255da.svg";